<template>
	<dl class="im-section aside-container">
		<dt>
			<div><a href="javascript:;" :class="{active: currentTpl == 'userInfo', disabled: disabledUserInfo}" @click="switchTab('userInfo')">客户信息</a></div>
			<div><a href="javascript:;" :class="{active: currentTpl == 'quickReply'}" @click="switchTab('quickReply')">快捷回复</a></div>
			<div><a href="javascript:;" :class="{active: currentTpl == 'aiTpl'}" @click="switchTab('aiTpl')">知识库</a></div>
		</dt>
		<dd>
			<userInfoTpl v-if="currentShop.serviceType == $store.state.TYPES.WANGWANG" v-show="currentTpl == 'userInfo'"></userInfoTpl>
			<wxUserInfoTpl v-else v-show="currentTpl == 'userInfo'"></wxUserInfoTpl>
			<quickReplyTpl v-show="currentTpl == 'quickReply'"></quickReplyTpl>
			<aiStorTpl v-show="currentTpl == 'aiTpl'"></aiStorTpl>
			<msgLogTpl v-show="$store.state.showMsgLog"></msgLogTpl>
			<optimizationAiAnswerTpl v-show="$store.state.showOptimizationAi"></optimizationAiAnswerTpl>
		</dd>
	</dl>
</template>

<script>
import userInfoTpl from './userInfoTpl.vue'
import wxUserInfoTpl from './wxUserInfoTpl.vue'
import quickReplyTpl from './quickReplyTpl.vue'
import aiStorTpl from './aiStorTpl.vue'
import msgLogTpl from './msgLogTpl.vue'
import optimizationAiAnswerTpl from './optimizationAiAnswerTpl.vue'
export default {
	name: 'asideContainer',
	data () {
		return {
			currentTpl: 'quickReply', // 可选值有：quickReply(快捷回复)、userInfo(客户信息)、aiStor(知识库)、workOrder(工单)
			disabledUserInfo: true
		}
	},
	computed: {
		currentShop () {
			return this.$store.state.currentShop;
		},
		currentConversation () {
			return this.$store.state.currentConversation;
		},
		userStatus () {
			return this.$store.state.userStatus;
		}
	},
	components: {
		'userInfoTpl': userInfoTpl,
		'wxUserInfoTpl': wxUserInfoTpl,
		'quickReplyTpl': quickReplyTpl,
		'aiStorTpl': aiStorTpl,
		'msgLogTpl': msgLogTpl,
		'optimizationAiAnswerTpl': optimizationAiAnswerTpl
	},
	watch: {
		currentConversation: {
			deep: true,
			handler (now, old) {
				var self = this;
				if (now.id == old.id) return;
				if (now.id) {
					this.initAsideTpl(now.id);
				} else {
					setTimeout(function() {
						self.initAsideTpl(now.id);
					}, 300);
				}
			}
		}
	},
	methods: {
		// 初始化附加模版
		initAsideTpl (sessionId) {
			var self = this;

			self.$store.commit('changeShowMsgLog', false);
			self.$store.commit('changeShowOptimizationAi', false);
			
			if (!sessionId) {
				if (self.currentConversation.id) return;
				self.currentTpl = 'quickReply';
				self.disabledUserInfo = true;
				return;
			}

			self.currentTpl = 'userInfo';
			self.disabledUserInfo = false;
		},

		// 切换tab
		switchTab (tplName) {
			var self = this;

			if (tplName == 'userInfo' && self.disabledUserInfo) return;
			self.currentTpl = tplName;
		}
	}
}
</script>


// WEBPACK FOOTER //
// src/pages/aside/asideContainer.vue